const DOGE = ({ ...props }) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10.874" r="10" fill="#BFA64A" />
    <path
      d="M6.22755 5.41064H10.2181C11.8537 5.41064 13.1284 5.88517 14.0421 6.83423C14.9558 7.78328 15.4127 9.12105 15.4127 10.8475C15.4127 12.579 14.9558 13.9269 14.0421 14.8911C13.1284 15.8553 11.8537 16.3374 10.2181 16.3374H6.22755V5.41064ZM8.1812 7.0614V14.6867H10.0137C11.1142 14.6867 11.9572 14.3585 12.5428 13.7023C13.1284 13.046 13.4212 12.0969 13.4212 10.8551C13.4212 9.63344 13.1259 8.697 12.5352 8.04579C11.9446 7.38953 11.1041 7.0614 10.0137 7.0614H8.1812Z"
      fill="white"
    />
    <path
      d="M11.6594 9.89228V11.8559H4.75L4.75 9.89228H11.6594Z"
      fill="white"
    />
  </svg>
);
export default DOGE;
